import { useState, useEffect } from 'react';

const useWindowHeight = () => {
  // State to track the window height
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // Function to update window height
  const handleResize = () => {
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    // Add event listener on component mount
    window.addEventListener('resize', handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  // Return the current window height
  return windowHeight;
};

export default useWindowHeight;
